/**
 * Утилиты для работы со временем
 */

/**
 * Получает текущее время в формате МСК (Московское время)
 * @returns Строка с временем в формате "DD.MM.YYYY, HH:mm:ss МСК"
 */
export function getMoscowTime(): string {
  const now = new Date();
  const moscowTimeStr = now.toLocaleString("ru-RU", {
    timeZone: "Europe/Moscow",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  return moscowTimeStr.replace(",", "") + " МСК";
}

